import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {takeUntilDestroy} from 'take-until-destroy';
import {PatientAccountService} from "../../../services/patient.account.service";
import {IPatientSearchResult} from "../common/common.types";
//import {WebFormContainerComponent} from "../../../../common/components/web.form.container/web.form.container.component";
import {LogManager} from "../../../../common/log/log.manager";
import {LogCat} from "../../../../common/log/log.categories";
import {AppConfigurationService} from "../../../../common/app-config/app-configuration.service";
import {WebFormLightContainerComponent} from "../../../../common/components/web.form.light.container/web.form.light.container.component";
import {PreLoginSystemConfigurationValues} from "../../../../common/configuration/services/prelogin.system.configuration.manager";

@Component({
  selector: 'app-patient-search',
  templateUrl: './patient.search.component.html',
  styleUrls: ['./patient.search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientSearchComponent implements OnInit, OnDestroy {
  @ViewChild('SearchPatientForm', {static: false}) searchPatientForm: WebFormLightContainerComponent;
  @Output() next = new EventEmitter();
  @Output() error = new EventEmitter();
  @Output() giveBackFocus = new EventEmitter();

  public patientSearchURL: string;
  public patientDataValidated = false;
  public showForm = false;
  public continueClicked = false;

  constructor(private changeDetector: ChangeDetectorRef,
              private patientAccountSvc: PatientAccountService,
              private cfg:PreLoginSystemConfigurationValues,
              private appConfigService: AppConfigurationService) {
  }

  ngOnInit() {
    this.cfg.GetPatientSearchForm().subscribe(form=>{
      this.patientSearchURL = this.appConfigService.Config.webForms.patientSearchURL;
      this.patientSearchURL = this.patientSearchURL.replace("@FORM_NAME@",form);
      this.showForm=true;
      this.changeDetector.markForCheck();
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.giveBackFocus.emit(true);
    }, 0);
  }

  ngOnDestroy() {

  }

  public continue() {
    if (!this.continueClicked) {
      this.continueClicked = true;
      this.changeDetector.markForCheck();
      this.searchPatientForm.patientForSave().then(patientReadForSave => {
        this.searchPatient(patientReadForSave);
      });
    }
  }

  public setPatient(patient: any) {
    this.continueClicked = false;
    this.changeDetector.markForCheck();
    this.searchPatientForm.setData(patient,false);
  }

  public reset() {
    this.showForm = false;
    this.continueClicked = false;
    this.changeDetector.markForCheck();
    setTimeout(() => {
      this.showForm = true;
      this.changeDetector.markForCheck();
    }, 10);
  }

  public dataValidated(valid: boolean) {
    this.patientDataValidated = valid;
    this.changeDetector.markForCheck();
  }

  private searchPatient(patient: any) {
    this.patientAccountSvc.locatePatient(patient)
      .pipe(takeUntilDestroy(this))
      .subscribe(res => {
          const searchPatientResult: IPatientSearchResult = {
            patient,
            locatePatientRes: res
          };
          this.next.emit(searchPatientResult);
        },
        err => {
          LogManager.error(LogCat.Login.CreatePatientAccount, err);
          this.error.emit(patient);
        });
  }

}
